// 7.2.9 SameValue(x, y)
module.exports = Object.is || function is(x, y) {
  // eslint-disable-next-line no-self-compare
  return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
};



//////////////////
// WEBPACK FOOTER
// ./~/core-js/modules/_same-value.js
// module id = 164
// module chunks = 0 1